import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentBridgeComponent } from './payment-bridge/payment-bridge.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BtnLoadingModule } from '../btn-loading/btn-loading.module';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    BtnLoadingModule
  ],
  declarations: [PaymentBridgeComponent],
  entryComponents: [PaymentBridgeComponent]
})
export class PaymentModule { }
